import { attributesAllergensClient } from '../../../app/services/api/attributesAllergens';

const useAttributesAllergensApi = () => {
  return attributesAllergensClient;
};

export default useAttributesAllergensApi;
